'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdAirlineSeatFlatAngled = function MdAirlineSeatFlatAngled(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm12.2 17q-1.9 0.9-3.9 0.2t-2.8-2.5-0.2-3.9 2.5-2.8 3.9-0.2 2.8 2.5 0.2 3.9-2.5 2.8z m-9.7 3.2l1.2-3.1 31.6 11.4-1.1 3.1-7.6-2.6v2.6h-13.2v-7.5z m34.6 3.6l-1.2 3.2-20.6-7.5 3.5-9.4 14.2 5.1q2.7 1 3.9 3.5t0.2 5.1z' })
        )
    );
};

exports.default = MdAirlineSeatFlatAngled;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/airline-seat-flat-angled.js
// module id = 2037
// module chunks = 0